import { render, staticRenderFns } from "./table-general-regional-nucleus-health.vue?vue&type=template&id=71e36f8d&scoped=true&"
import script from "./table-general-regional-nucleus-health.vue?vue&type=script&lang=js&"
export * from "./table-general-regional-nucleus-health.vue?vue&type=script&lang=js&"
import style0 from "./table-general-regional-nucleus-health.vue?vue&type=style&index=0&id=71e36f8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e36f8d",
  null
  
)

export default component.exports